import mammoth from 'mammoth'

export async function parseDocx(file: File): Promise<string> {
  const arrayBuffer = await file.arrayBuffer()
  const result = await mammoth.extractRawText({ arrayBuffer })
  // mammoth returns { value: string, messages: [] }
  // An empty string is valid (file may contain only images)
  if (result.value === undefined || result.value === null) {
    throw new Error('Failed to extract text from DOCX file')
  }
  return result.value
}
